import { post } from '@/lib/request/index';
import { address } from '../apiConstants';

// 搜索地址
export function addressSearch(param) {
  return post(address.ADDRESS_SEARCH, { param })
    .then((data) => data)
    .catch((err) => {
      console.log('err', err);
      return false;
    });
}

// 获取历史地址
export function addressHistoryList(param) {
  return post(address.ADDRESS_LIST, { param })
    .then((data) => data)
    .catch((err) => {
      return false;
    });
}

// 地址删除
export function addressDel(param) {
  return post(address.ADDRESS_DEL, { param })
    .then((data) => data)
    .catch((err) => {
      return false;
    });
}

// 地址校验
export function poiCheck(param) {
  return post(address.POI_CHECK, { param })
    .then((data) => data)
    .catch((err) => {
      return false;
    });
}

/**
 * 批量查询POI地址
 * @param map // {'array index': 'address string'}
 * @returns {*}
 */
export function batchQueryAddressPoi({ map }) {
  map = JSON.stringify(map);
  return post(address.BATCH_QUERY_ADDRESS_POI, {
    param: { queryJson: map },
  }).then((data) => data);
}
